import * as Yup from 'yup';

import { userExist } from '@utils/backend-api/users';
import { EMAIL_REGEX } from '@utils/constants';

const validationSchema = () =>
  Yup.object({
    email: Yup.string()
      .nullable()
      .required('You must enter a valid email address')
      .test('is-valid-or-exists', 'You must enter a valid email address', async function (value) {
        if (!value) return false;

        const emailRegex = EMAIL_REGEX;
        if (emailRegex.test(value)) return true;

        try {
          const { success } = await userExist(value);
          return success;
        } catch (err) {
          return false;
        }
      }),
  });
export default validationSchema;
